<template>
  <div
    class="star-box sentinel-box"
    tabindex="0"
  >
    <button
      v-for="(icon, index) in ratingsIcon"
      :key="icon.id" 
      :disabled="disabled"
      class="star-btn tab-focused-btn"
      aria-pressed="false"
      @click.stop="(event) => onRatingClick(event, index)"
    >
      <div :class="getClassNames(icon)">
        {{ icon.id }}
      </div>
    </button>
  </div>
</template>

<script>
  // Val will be className - '', or 'rating-filled'
  const DEFAULT_RATING = [
    { id: '1', val: '' },
    { id: '2', val: '' },
    { id: '3', val: '' },
    { id: '4', val: '' },
    { id: '5', val: '' },
    { id: '6', val: '' },
    { id: '7', val: '' },
    { id: '8', val: '' },
    { id: '9', val: '' },
    { id: '10', val: '' },
  ];

  export default {
    name: 'NumberRating',
    props: {
      ratingChanged: {
        type: Function,
        default: () => {},
      },
      schema: {
        type: Object,
        default: () => {},
      },
      numericRating: {
        type: Number,
        default: 5
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        ratingsIcon: DEFAULT_RATING.slice(0, this.numericRating),
      };
    },
    watch: {
      schema() {
        this.ratingsIcon = DEFAULT_RATING;
      },
    },
    methods: {
      onRatingClick(event, index) {
        this.ratingsIcon = this.ratingsIcon.map((ele, i) => {
          return i === index ? { id: ele.id, val: 'rating-filled' } : { id: ele.id, val: '' };
        });
        let node = event.target
        while (node?.tagName !== 'BUTTON') node = node?.parentNode
        if (node) node.attributes['aria-pressed'].nodeValue = true
        
        this.ratingChanged(index + 1);
      },
      getClassNames(icon) {
        return `num-ratings ${icon.val} ${this.disabled ? 'num-ratings-btn-disabled': ''}`
      }
    },
  };
</script>
<style lang="scss" scoped>
  .star-box {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
    .star-btn {
      .num-ratings {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 6px 12px;
        gap: 4px;
        width: 32px;
        height: 32px;
        border: 1px solid #6d6d6d;
        border-radius: 4px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        &.num-ratings-btn-disabled {
          cursor: not-allowed;
        }
      }
    }
  }
  .rating-filled {
    background: var(--widget-primary-color);;
    color: #FFFFFF;
  }
</style>
